package com.patronat.top.features.usermanagement.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.features.usermanagement.domain.repository.ProfileRepository
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.features.usermanagement.domain.models.FilteredUsers
import com.patronat.top.features.usermanagement.domain.usecase.command.GetFilteredUsersCommand

class GetUsersUseCase(
    val userRepository: ProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetFilteredUsersCommand, DomainResult<FilteredUsers>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetFilteredUsersCommand): DomainResult<FilteredUsers> {
        return userRepository.getFilteredUsers(command.userFilter)
    }
}